import styled from "@emotion/styled";
import Card from "@material-ui/core/Card";
import { units } from "../../../../types/units";

export const StyledCard = styled(Card)`
  width: 220px;
  display: inline-block;
  font-family: ${(props) => props.theme.fontFamily.primary};
  min-height: 255px;
  border: 1px solid transparent;
  ${units({
    textDecoration: "none",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "lighterBlue",
      borderColor: "skyBlue",
    },
  })}
`;
